import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export const convertToTimeFormat = (timeInMilliSecs) => {
    const seconds = moment.duration(timeInMilliSecs).seconds();
    const minutes = moment.duration(timeInMilliSecs).minutes();
    const hours = Math.trunc(moment.duration(timeInMilliSecs).asHours());
  
    return hours+":"+minutes+":"+seconds;
}
  
export default function(holdTime) {
  const column = {
    Header: 'Hold Time',
    show: holdTime,
    id: 'holds',
    accessor: d => d.holds,
    Cell: ({ value }) => {
        let holdTime = "00:00:00";
        if (value && value.length > 0) {
            let duration = value?.[0]?.holdStateDuration;
            holdTime = typeof duration !== 'undefined' ? convertToTimeFormat(duration) : holdTime;
        }
        
        return <span title={holdTime}>{holdTime}</span>;
    }
  };

  column.Cell.propTypes = {
    value: PropTypes.any
  };

  return column;
}